export const RECODE_TYPE_PREFIX = "recode:";

export const RECODE_KIND_DEFAULTS = {
  conditions: { recodeType: "conditions", transformationType: "Conditions (Single)" },
  open_end: { recodeType: "question", transformationType: "Multiple Match (Closed)" },
  interview_codification: { recodeType: "ai_chat_recode", transformationType: "Multiple Match (Closed)" },
  mailing: { recodeType: "contact_attribute", transformationType: null },
  url_param: { recodeType: "question", transformationType: "URL parameter" },
  geo: { recodeType: "question", transformationType: null },
  group_answers: { recodeType: "question", transformationType: null },
};

const GROUP_ANSWERS_TRANSFORMATION_TYPES = [
  "Single Match (Closed)",
  "Multiple Match (Closed)",
  "Single Match (Matrix)",
  "Multiple Match (Matrix)",
  "User attribute",
  "User attribute (Multiple)",
];

const GEO_TRANSFORMATION_TYPES = [
  "UDA5",
  "UDA9",
  "Metropolitan Regions",
  "Metropolitan & Overseas Regions",
  "Departement",
];
const AI_SENTINELS = { open_ai_recode: "open_end", ai_chat_recode: "interview_codification" };

export function kindFromSpecs(specs = {}) {
  const sentinelKind = AI_SENTINELS[specs.ranges?.[0]?.from];
  if (sentinelKind) return sentinelKind;
  const type = specs.transformation_type;
  if (type?.startsWith("Conditions")) return "conditions";
  if (type === "URL parameter") return "url_param";
  if (type?.startsWith("Mailing contact attribute") || specs.recode_type === "contact_attribute") return "mailing";
  if (GEO_TRANSFORMATION_TYPES.includes(type)) return "geo";
  if (GROUP_ANSWERS_TRANSFORMATION_TYPES.includes(type)) return "group_answers";
  return null;
}

const PRODUCT_KIND_ALIASES = {
  single_match: "group_answers",
  multiple_match: "group_answers",
  matrix: "group_answers",
  user_attribute: "group_answers",
  interview_extraction: "interview_codification",
};

export function productKind(card) {
  const raw = card?.recode_kind || kindFromSpecs(card?.specs || {});
  return PRODUCT_KIND_ALIASES[raw] || raw;
}

export const isRecodeTypeKey = (key) => typeof key === "string" && key.startsWith(RECODE_TYPE_PREFIX);
export const recodeKindFromTypeKey = (key) => (isRecodeTypeKey(key) ? key.slice(RECODE_TYPE_PREFIX.length) : null);
export const recodeTypeKey = (kind) => `${RECODE_TYPE_PREFIX}${kind}`;
